import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  label: string;
  isTopScrolled: boolean;
  scrollContainer: HTMLDivElement | null;
  onLoadMore: () => void;
};

const LoadMoreButton: FC<Props> = ({
  label,
  isTopScrolled,
  scrollContainer,
  onLoadMore,
}) => {
  const handleClick = () => {
    onLoadMore();
  };

  return (
    <div
      className={`flex justify-center py-2 mb-2 w-full max-md:pb-[env(safe-area-inset-bottom)] ${isTopScrolled ? "max-md:!hidden" : ""}`}
    >
      <Button
        variant="outline"
        className="bg-secondary rounded-full mt-2"
        onClick={handleClick}
      >
        {label}
        <HugeiconsIcon icon={ArrowDown01Icon} />
      </Button>
    </div>
  );
};

export default LoadMoreButton;
